import { gql } from "@apollo/client";

export default gql`
  fragment StripePlanFields on StripePlan {
    name
    displayName
    tier
    recurrency
    price
    planId
    productId
    viewerIsSubscribed
    upgradeToPlan {
      planId
      name
    }
    limits {
      teamMembers
      products
      enrichedProducts
      groups
      groupInvitations
      sharingPage
      projectsPerMonth
      productTags
      searchAccess
    }
    changeDetails {
      prorateCost
      proratePaymentDueDate
      firstInvoiceAfterProrateDate
    }
  }
`;
